import { useContext } from 'react';
import { EffectContext } from '../../../../../common/view/effect/effect.context';
import { MonoIcon } from '../../../../../common/view/icon/mono/mono-icon';
import { ImmerFuncs } from '../../../../../external/immer/immer.funcs';
import { ServerApi } from '../../../../../external/server/server.api';
import { ArrayFuncs } from '../../../../../foundation/js/array.funcs';
import { EffectTypeWire } from '../../../../core/effect/effect-type.wire';
import { EffectWireFuncs } from '../../../../core/effect/effect.wire.func';
import { NodeStore } from '../../../../core/node/node.store';
import { EffectMenuItem } from '../../effect-menu-item';

export function LastTimeEffectMenuItem({ nodeId }: { nodeId: string }) {
  const node = NodeStore.useItem(nodeId);
  const effect = ArrayFuncs.ensure(node.effects).find((e) => e.type === EffectTypeWire.lastTime);
  const { popupApi } = useContext(EffectContext);

  if (effect) {
    return null;
  }

  function handleClick() {
    popupApi.pop();
    const effects = ArrayFuncs.ensure(node.effects);
    const newEffects = ImmerFuncs.produce(effects, (draft) => {
      EffectWireFuncs.addEffect({ effects: draft, effect: EffectWireFuncs.init({ type: EffectTypeWire.lastTime }) });
    });
    NodeStore.updateItem(nodeId, { effects: newEffects });
    ServerApi.updateNode(nodeId, { effects: newEffects });
  }

  return (
    <EffectMenuItem
      icon={MonoIcon.lastTime}
      iconColor={'#E40078'}
      title={'Show Time Since Last'}
      subtitle={'It has been 2 weeks since washing bed sheets'}
      onClick={handleClick}
    />
  );
}
